import { useState } from "react";
import { Loader2 } from "lucide-react";
import { adminApi, apiError, setToken } from "@/lib/api";
import { ForgotPasswordForm } from "./ForgotPasswordForm";

export const AdminLogin = ({ onLogged }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [forgot, setForgot] = useState(false);
  const resetOk = new URLSearchParams(window.location.search).get("reinitialise") === "1";

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const { data } = await adminApi.post("/login", { email, password });
      setToken(data.token);
      window.history.replaceState(null, "", "/admin");
      onLogged(data.email);
    } catch (err) {
      setError(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-ice-soft flex items-center justify-center px-5">
      {forgot ? (
        <ForgotPasswordForm onBack={() => setForgot(false)} />
      ) : (
        <form onSubmit={submit} data-testid="admin-login-form" className="order-card w-full max-w-sm p-8 flex flex-col gap-4">
          <div>
            <span className="font-display text-2xl font-extrabold text-slate-900">ClimNova</span>
            <p className="text-sm text-slate-500">Espace administration</p>
          </div>
          {resetOk && (
            <div data-testid="admin-reset-success" className="rounded-xl bg-emerald-50 border border-emerald-200 text-emerald-800 text-sm px-4 py-3">
              Mot de passe réinitialisé. Connectez-vous avec votre nouveau mot de passe.
            </div>
          )}
          <input data-testid="admin-email-input" type="email" placeholder="E-mail" value={email} onChange={(e) => setEmail(e.target.value)} className="field-input" required />
          <input data-testid="admin-password-input" type="password" placeholder="Mot de passe" value={password} onChange={(e) => setPassword(e.target.value)} className="field-input" required />
          {error && <div data-testid="admin-login-error" className="text-sm text-red-600">{error}</div>}
          <button type="submit" disabled={loading} data-testid="admin-login-button" className="btn-heat">
            {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : "Se connecter"}
          </button>
          <button type="button" onClick={() => setForgot(true)} data-testid="admin-forgot-password-link" className="text-sm text-sky-700 hover:underline self-center">
            Mot de passe oublié ?
          </button>
        </form>
      )}
    </div>
  );
};
